import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class ResponsavelDBService extends DatabaseService {
    override classname: string = 'ResponsavelDBService';
    override table = 'responsavel';

    protected override migration: number = 1;

    override indices = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_nome", field: "pessoa.nome", unique: false, multiEntry: false },
        { name: "by_sinc", field: "sinc", unique: false, multiEntry: false }
    ];
}
